import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const catalogEntry = fgColumnEntries["electronic-com-invoice"];

function getElectronicCommercialInvoice(row: FulfillmentGroupData): string {
  if (!row?.shipment?.label?.commercialInvoiceUrl) {
    return "N/A";
  }

  return row?.shipment?.label?.comInvoiceSubmittedElectronically
    ? "true"
    : "false";
}

export const CommercialInvoiceSubmittedElectronicallyColumn: Column2<FulfillmentGroupData> =
  {
    key: catalogEntry.key,
    title: catalogEntry.title,
    alignment: ColumnAlignment.LEFT,
    renderNormalCell: ({ row }) => {
      return <RedoTableTextCell text={getElectronicCommercialInvoice(row)} />;
    },
    width: catalogEntry.defaultWidth,
    hidden: true,
  };
